module.exports = __webpack_public_path__ + "static/media/caller.5ef6ad8e.jpg";